import LiquidityPage from './pages/Liquidity.vue'
import BoardPage from './pages/Board.vue'
import ScraperLogsPage from './pages/ScraperLogs.vue'
import ScraperSettingsPage from './pages/ScraperSettings.vue'
import CyclesPage from './pages/Cycles.vue'

/**
 * Register desk-module Nova Vue pages.
 *
 * @param {import('vue').App} app
 */
const heatmapModuleSetup = (app) => {
  app.inertia('Desk.Liquidity', LiquidityPage)
  app.inertia('Desk.Board', BoardPage)
  app.inertia('Desk.ScraperLogs', ScraperLogsPage)
  app.inertia('Desk.ScraperSettings', ScraperSettingsPage)
  app.inertia('Desk.Cycles', CyclesPage)
}

export { heatmapModuleSetup }
